import { jsx as _jsx } from "react/jsx-runtime";
import { Divider as MuiDivider } from '@mui/material';
import { HelixPalette } from '../../helix';
/**
 * Page dividing line.
 */
export const Divider = ({ color = HelixPalette.neutral10, height = 'auto', margin, orientation = 'horizontal', style }) => {
    if (orientation === 'vertical')
        return (_jsx(MuiDivider, { "data-id": "divider", flexItem: true, orientation: "vertical", sx: { borderColor: color, height, margin: margin || '0 1rem', width: 'fit-content' }, style: Object.assign({}, style) }));
    return _jsx(MuiDivider, { "data-id": "divider", sx: { borderColor: color, margin: margin || '1rem 0', width: '100%' }, style: Object.assign({}, style) });
};
export default Divider;
